<template>
  <div class="league-banner" @click="$router.push(`/prematch/sport/${banner.sport}/league/${banner.league}`)">
    <img
      style="width: 429px;"
      alt="#"
      :src="require('@/assets/banners/leagues/320x100-' + banner.alias + '.jpg')">
  </div>
</template>

<script>
export default {
  props: {
    banner: Object
  }
}
</script>

<style scoped>
.league-banner { width:429px; cursor: pointer; height: auto; opacity: .9; overflow: hidden; position: relative;  -webkit-transition: opacity .3s; -moz-transition: opacity .3s; -o-transition: opacity .3s; transition: opacity .3s; border-radius: 10px; height: 241px; }
.league-banner:hover { opacity: 1; }
</style>



// WEBPACK FOOTER //
// src/components/LeagueBanner.vue